import { takeLatest, call, put, select } from 'redux-saga/effects';
import axios from 'axios';
import {
  getUserProgramsFullRequest,
  getUserProgramsFullSuccess,
  getUserProgramsFullFailure,
} from '../reducers/userProgramsFull';
import { API_LINK } from '../../constants';
import { systemRequest } from '../reducers/system'

const API = `${API_LINK}api/user/`;

function* getUserProgramsFullAxios() {
  const state = yield select(fullState => fullState);
  const {
    user: { userId },
    token,
  } = state.loginReducer;

  return yield call(() =>
    axios({
      method: 'get',
      url: `${API}${userId}/programs`,
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        Authorization: `Bearer ${token}`,
      },
    }),
  );
}

function* workerGetUserProgramsFullSaga() {
  try {
    const response = yield call(getUserProgramsFullAxios);

    const responseFromGetUsersProgramsFull = response.data.data;
    console.log('Module',responseFromGetUsersProgramsFull)
    switch (response.status) {
      case 200:
        yield put(getUserProgramsFullSuccess(responseFromGetUsersProgramsFull));
        yield put(systemRequest());
        break;
      case 205:
      case 206:
      case 500:
        yield put(getUserProgramsFullFailure(responseFromGetUsersProgramsFull));
        break;
      default:
        break;
    }
  } catch (error) {
    yield put(getUserProgramsFullFailure(error));
  }
}

export function* watcherGetUserProgramsFullSaga() {
  yield takeLatest(getUserProgramsFullRequest().type, workerGetUserProgramsFullSaga);
}



// WEBPACK FOOTER //
// ./src/redux/sagas/get_getUserProgramsFull.js